// extracted by mini-css-extract-plugin
export default {"cover":"_152Mg","hasActiveState":"_3rmLe"};